import React, { useState, useEffect } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerFooter,
  Checkbox,
  Button,
  background,
} from "@chakra-ui/react";
import CryptoJS from "crypto-js";
import "./User.css";
import {
  TableContainer,
  Thead,
  Tbody,
  Table,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { addRole, updateRole } from "../../redux/api/rolesApi/RoleApi";
import {
  addroleAction,
  updateroleAction,
} from "../../redux/reduxSlice/RoleSlice";
import ProgressBar from "../../utils/progressBar/ProgressBar";
import Modules from "./Modules";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
function UserDrawer(props) {
  const {
    updateMode,
    isUpdateMode,
    dataToEdit,
    formData: initialFormData,
    setIsUpdateMode,
    roleId,
  } = props;
  const [permissions, setPermissions] = useState(false);
  const [activeButton, setActiveButton] = useState("");

  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const userId = localStorage.getItem("userId");

  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
    createdBy: userId,
    permissions: [
      {
        moduleName: "Lead",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
        subModules: [
          {
            moduleName: "Field Sale",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Imported Lead",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Tele Sale",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Telesale Manager",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Senior Telesales",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Kyc Department",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Surveyor",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
          {
            moduleName: "Pre Sale",
            add: false,
            viewAll: false,
            fullAccess: false,
            modifyAll: false,
            delete: false,
            assignOwner: false,
          },
        ],
      },
      {
        moduleName: "Deal",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "DMS",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Client",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Company",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Quote",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Walkthrough",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Task master",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
        {
        moduleName: "DMS Master",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      //operations
      {
        moduleName: "Site",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Inspection",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Survey",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Map",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      //Finance
      {
        moduleName: "Sales Order",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Invoice",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Payment Receive",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Customer Ledger",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Vendor",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Purchase Order",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Inventory",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Bill",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      //HRM
      {
        moduleName: "Employee",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Attendance",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
      {
        moduleName: "Department",
        add: false,
        viewAll: false,
        fullAccess: false,
        modifyAll: false,
        delete: false,
        assignOwner: false,
      },
    ],
  });
  const modules = [...Modules];
  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;

    // Handle roleName and roleDescription separately
    if (name === "roleName" || name === "description") {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      return;
    }

    const [moduleName, permissionName] = name.split("_");

    setFormData((prevState) => ({
      ...prevState,
      permissions: prevState.permissions.map((module) => {
        if (module.moduleName.toLowerCase() === moduleName.toLowerCase()) {
          if (permissionName?.toLowerCase() === "fullaccess") {
            return {
              ...module,
              fullAccess: checked,
              add: checked,
              viewAll: checked,
              modifyAll: checked,
              delete: checked,
              assignOwner: checked,
              subModules: module.subModules?.map((sub) => ({
                ...sub,
                fullAccess: checked,
                add: checked,
                viewAll: checked,
                modifyAll: checked,
                delete: checked,
                assignOwner: checked,
              })),
            };
          } else {
            return {
              ...module,
              [permissionName]: checked,
              viewAll:
                permissionName !== "viewAll" &&
                (checked ||
                  module.add ||
                  module.modifyAll ||
                  module.delete ||
                  module.assignOwner)
                  ? true
                  : module.viewAll,
              fullAccess:
                module.add &&
                module.viewAll &&
                module.modifyAll &&
                module.delete &&
                module.assignOwner,
            };
          }
        }

        if (module.subModules) {
          const updatedSubModules = module.subModules.map((sub) => {
            if (sub.moduleName.toLowerCase() === moduleName.toLowerCase()) {
              if (permissionName?.toLowerCase() === "fullaccess") {
                return {
                  ...sub,
                  fullAccess: checked,
                  add: checked,
                  viewAll: checked,
                  modifyAll: checked,
                  delete: checked,
                  assignOwner: checked,
                };
              } else {
                return {
                  ...sub,
                  [permissionName]: checked,
                  viewAll:
                    permissionName !== "viewAll" &&
                    (checked ||
                      sub.add ||
                      sub.modifyAll ||
                      sub.delete ||
                      sub.assignOwner)
                      ? true
                      : sub.viewAll,
                  fullAccess:
                    sub.add &&
                    sub.viewAll &&
                    sub.modifyAll &&
                    sub.delete &&
                    sub.assignOwner,
                };
              }
            }
            return sub;
          });

          return {
            ...module,
            subModules: updatedSubModules,
          };
        }

        return module;
      }),
    }));
  };

  const { closeDrawer } = props;
  const handleOnClose = () => {
    closeDrawer();
    setFormData({ ...formData, formData: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formData", formData);
    setShowProgressBar(true);
    addRole(formData)
      .then((response) => {
        if (response.data.success) {
          dispatch(addroleAction({ ROWID: response.data.rowId, formData }));
          toast.success("Role added successfully!");
          setFormData();
        }
        setTimeout(() => {
          handleOnClose();
          setShowProgressBar(false);
        }, 300);
      })
      .catch((error) => {
        setShowProgressBar(false);
        toast.error("Role not added!");
      })
      .finally(() => {
        setShowProgressBar(false);
      });
  };
  // UpdateMode Use-effect
  // useEffect(() => {
  //     if (isUpdateMode && dataToEdit) {
  //         const parsedPermission = typeof dataToEdit.permissions === "string" ?

  //             JSON.parse(dataToEdit.permissions || "[]") : dataToEdit.permissions
  //         setFormData((prev) => ({
  //             ...prev, ...dataToEdit,
  //             permissions: parsedPermission,
  //         }
  //         ))
  //     }
  // }, [isUpdateMode, dataToEdit]);

  const mergePermissions = (defaults, existing) => {
    return defaults.map((defaultPerm) => {
      const existingPerm = existing.find(
        (p) => p.moduleName === defaultPerm.moduleName
      );
      if (!existingPerm) return defaultPerm;

      const merged = { ...defaultPerm, ...existingPerm };

      if (defaultPerm.subModules && Array.isArray(defaultPerm.subModules)) {
        merged.subModules = defaultPerm.subModules.map((defaultSub) => {
          const existingSub = existingPerm.subModules?.find(
            (s) => s.moduleName === defaultSub.moduleName
          );
          return existingSub ? { ...defaultSub, ...existingSub } : defaultSub;
        });
      }

      return merged;
    });
  };

  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      const parsedPermission =
        typeof dataToEdit.permissions === "string"
          ? JSON.parse(dataToEdit.permissions || "[]")
          : dataToEdit.permissions;

      const mergedPermissions = mergePermissions(
        formData.permissions,
        parsedPermission
      );

      setFormData((prev) => ({
        ...prev,
        ...dataToEdit,
        permissions: mergedPermissions,
      }));
    }
  }, [isUpdateMode, dataToEdit]);

  // Handle Update Function
  const handelOnUpdate = (e) => {
    e.preventDefault();
    // Validation for required fields
    updateRole(roleId, formData)
      .then((response) => {
        setShowProgressBar(true);
        if (response.data.success) {
          console.log("response", response);
          setFormData((prev) => ({
            ...prev,
            ROWID: response?.data.ROWID,
          }));
          dispatch(updateroleAction(formData));
          toast.success("Role Updated SuccesFully !!");
        }
        setTimeout(() => {
          handleOnClose();
          setShowProgressBar(false);
          // setSubmitDisabled(false)
        }, 300);
      })
      .catch((error) => {
        console.log(error);
        setShowProgressBar(false);
        toast.error("role Updation Failed !");
      })
      .finally(() => {
        //   setSubmitDisabled(false);
        //   setShowProgressBar(false);
      });
  };

  // Function to handle toggle
  const handleAccordionToggle = (id) => {
    setActiveButton(activeButton === id ? null : id);
  };

  return (
    <>
      <Drawer
        placement="right"
        size="xl"
        onClose={props.closeDrawer}
        isOpen={props.isDrawerOpen}
        style={{ background: "pink" }}
      >
        <DrawerOverlay />
        <DrawerContent overflow="scroll">
          <DrawerHeader borderBottomWidth="1px">
            {isUpdateMode ? "Update Role" : "New Role"}
          </DrawerHeader>
          <DrawerBody overflow="scroll">
            {showProgressBar && <ProgressBar colorScheme="pink" />}
            <div className="">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Role Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  placeholder="Role Name"
                  name="roleName"
                  value={formData?.roleName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label for="exampleFormControlTextarea1" className="form-label">
                  Description<span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  name="description"
                  value={formData?.description}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  onClick={() => handleAccordionToggle("accrodian1")}
                >
                  <button
                    className="accordion-button collapsed bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    CRM Permission
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse "
                  data-bs-parent="#accordionExample"
                  style={{
                    display: activeButton === "accrodian1" ? "block" : "none",
                  }}
                >
                  <div className="card mb-3">
                    <div
                      className="card-body p-1"
                      style={{ background: "#F3F3F1" }}
                    >
                      <TableContainer
                        className="card card-detail mt-1 w-100"
                        style={{ height: "200px", overflowY: "auto" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button d-none"
                          table="table-to-xls"
                          filename="Lead List"
                          sheet="tablexls"
                          buttonText="Export"
                        />
                        <Table
                          id="table-to-xls"
                          className="leadNoPadding"
                          variant="simple"
                          size="sm"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 100,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Tr className="bg-white">
                              <Th></Th>
                              <Th className="text-center py-1">Full Access</Th>
                              <Th className="text-center py-1">View</Th>
                              <Th className="text-center py-1">Create</Th>
                              <Th className="text-center py-1">Edit</Th>
                              <Th className="text-center py-1">Delete</Th>
                              <Th className="text-center py-1">Assign owner</Th>
                              <Th></Th>
                            </Tr>
                          </Thead>
                          {/* <Tbody>
                                                            {formData?.permissions?.slice(0, 6).map((module, index) => (
                                                                <Tr key={index} className="tr-border">
                                                                    <Td className="p-2">{module.moduleName}</Td>
                                                                    {["fullAccess", "viewAll", "add", "modifyAll", "delete", "assignOwner"].map((permission, idx) => (
                                                                        <Td key={idx} className="p-2 text-center font-colors">
                                                                            <input
                                                                                type="checkbox"
                                                                                name={`${module.moduleName.toLowerCase()}_${permission}`}
                                                                                onChange={handleChange}
                                                                                checked={module[permission] || false}
                                                                                className="form-checkbox mr-5"
                                                                            />
                                                                        </Td>
                                                                    ))}
                                                                </Tr>
                                                            ))}
                                                        </Tbody> */}
                          <Tbody>
                            {formData?.permissions
                              ?.slice(0, 9)
                              .map((module, index) => (
                                <React.Fragment key={index}>
                                  {/* Main Module Row */}
                                  <Tr className="tr-border">
                                    <Td className="p-2">{module.moduleName}</Td>
                                    {[
                                      "fullAccess",
                                      "viewAll",
                                      "add",
                                      "modifyAll",
                                      "delete",
                                      "assignOwner",
                                    ].map((permission, idx) => (
                                      <Td
                                        key={idx}
                                        className="p-2 text-center font-colors"
                                      >
                                        <input
                                          type="checkbox"
                                          name={`${module.moduleName.toLowerCase()}_${permission}`}
                                          onChange={handleChange}
                                          checked={module[permission] || false}
                                          className="form-checkbox mr-5"
                                        />
                                      </Td>
                                    ))}
                                  </Tr>

                                  {/* Sub Modules Inside Lead */}
                                  {module.subModules &&
                                    module.subModules.map(
                                      (subModule, subIndex) => (
                                        <Tr
                                          key={`${index}-${subIndex}`}
                                          className="tr-border"
                                        >
                                          <Td className="p-2 ps-4">
                                            — {subModule.moduleName}
                                          </Td>
                                          {[
                                            "fullAccess",
                                            "viewAll",
                                            "add",
                                            "modifyAll",
                                            "delete",
                                            "assignOwner",
                                          ].map((permission, subIdx) => (
                                            <Td
                                              key={subIdx}
                                              className="p-2 text-center font-colors"
                                            >
                                              <input
                                                type="checkbox"
                                                name={`${subModule.moduleName.toLowerCase()}_${permission}`}
                                                onChange={handleChange}
                                                checked={
                                                  subModule[permission] || false
                                                }
                                                className="form-checkbox mr-5"
                                              />
                                            </Td>
                                          ))}
                                        </Tr>
                                      )
                                    )}
                                </React.Fragment>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  onClick={() => handleAccordionToggle("accrodian2")}
                >
                  <button
                    className="accordion-button collapsed  bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Operation Permission
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                  style={{
                    display: activeButton === "accrodian2" ? "block" : "none",
                  }}
                >
                  <div className="card mb-3">
                    <div
                      className="card-body p-1"
                      style={{ background: "#F3F3F1" }}
                    >
                      <TableContainer
                        className="card card-detail mt-1 w-100"
                        style={{ height: "200px", overflowY: "auto" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button d-none"
                          table="table-to-xls"
                          filename="Lead List"
                          sheet="tablexls"
                          buttonText="Export"
                        />
                        <Table
                          id="table-to-xls"
                          className="leadNoPadding"
                          variant="simple"
                          size="sm"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 100,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Tr className="bg-white">
                              <Th></Th>
                              <Th className="text-center py-1">Full Access</Th>
                              <Th className="text-center py-1">View</Th>
                              <Th className="text-center py-1">Create</Th>
                              <Th className="text-center py-1">Edit</Th>
                              <Th className="text-center py-1">Delete</Th>
                              <Th className="text-center py-1">Assign owner</Th>
                              <Th></Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {formData?.permissions
                              ?.slice(9, 12)
                              .map((module, index) => (
                                <Tr key={index} className="tr-border">
                                  <Td className="p-2">{module.moduleName}</Td>
                                  {[
                                    "fullAccess",
                                    "viewAll",
                                    "add",
                                    "modifyAll",
                                    "delete",
                                    "assignOwner",
                                  ].map((permission, idx) => (
                                    <Td
                                      key={idx}
                                      className="p-2 text-center font-colors"
                                    >
                                      <input
                                        type="checkbox"
                                        name={`${module.moduleName.toLowerCase()}_${permission}`}
                                        onChange={handleChange}
                                        checked={module[permission] || false}
                                        className="form-checkbox mr-5"
                                      />
                                    </Td>
                                  ))}
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  onClick={() => handleAccordionToggle("accrodian3")}
                >
                  <button
                    className="accordion-button collapsed  bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Finance Permission
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                  style={{
                    display: activeButton === "accrodian3" ? "block" : "none",
                  }}
                >
                  <div className="card mb-3">
                    <div
                      className="card-body p-1"
                      style={{ background: "#F3F3F1" }}
                    >
                      <TableContainer
                        className="card card-detail mt-1 w-100"
                        style={{ height: "200px", overflowY: "auto" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button d-none"
                          table="table-to-xls"
                          filename="Lead List"
                          sheet="tablexls"
                          buttonText="Export"
                        />
                        <Table
                          id="table-to-xls"
                          className="leadNoPadding "
                          variant="simple"
                          size="sm"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 100,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Tr className="bg-white">
                              <Th></Th>
                              <Th className="text-center py-1">Full Access</Th>
                              <Th className="text-center py-1">View</Th>
                              <Th className="text-center py-1">Create</Th>
                              <Th className="text-center py-1">Edit</Th>
                              <Th className="text-center py-1">Delete</Th>
                              <Th className="text-center py-1">Assign owner</Th>
                              <Th></Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {formData?.permissions
                              ?.slice(12, 21)
                              .map((module, index) => (
                                <Tr key={index} className="tr-border">
                                  <Td className="p-2">{module.moduleName}</Td>
                                  {[
                                    "fullAccess",
                                    "viewAll",
                                    "add",
                                    "modifyAll",
                                    "delete",
                                    "assignOwner",
                                  ].map((permission, idx) => (
                                    <Td
                                      key={idx}
                                      className="p-2 text-center font-colors"
                                    >
                                      <input
                                        type="checkbox"
                                        name={`${module.moduleName.toLowerCase()}_${permission}`}
                                        onChange={handleChange}
                                        checked={module[permission] || false}
                                        className="form-checkbox mr-5"
                                      />
                                    </Td>
                                  ))}
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  onClick={() => handleAccordionToggle("accrodian4")}
                >
                  <button
                    className="accordion-button collapsed  bg-white"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    HRM Permission
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                  style={{
                    display: activeButton === "accrodian4" ? "block" : "none",
                  }}
                >
                  <div className="card mb-3">
                    <div
                      className="card-body p-1"
                      style={{ background: "#F3F3F1" }}
                    >
                      <TableContainer
                        className="card card-detail mt-1 w-100"
                        style={{ height: "200px", overflowY: "auto" }}
                      >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button d-none"
                          table="table-to-xls"
                          filename="Lead List"
                          sheet="tablexls"
                          buttonText="Export"
                        />
                        <Table
                          id="table-to-xls"
                          className="leadNoPadding "
                          variant="simple"
                          size="sm"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Thead
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 100,
                              backgroundColor: "white",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Tr className="bg-white">
                              <Th></Th>
                              <Th className="text-center py-1">Full Access</Th>
                              <Th className="text-center py-1">View</Th>
                              <Th className="text-center py-1">Create</Th>
                              <Th className="text-center py-1">Edit</Th>
                              <Th className="text-center py-1">Delete</Th>
                              <Th className="text-center py-1">Assign owner</Th>
                              <Th></Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {formData?.permissions
                              ?.slice(21, 25)
                              .map((module, index) => (
                                <Tr key={index} className="tr-border">
                                  <Td className="p-2">{module.moduleName}</Td>
                                  {[
                                    "fullAccess",
                                    "viewAll",
                                    "add",
                                    "modifyAll",
                                    "delete",
                                    "assignOwner",
                                  ].map((permission, idx) => (
                                    <Td
                                      key={idx}
                                      className="p-2 text-center font-colors"
                                    >
                                      <input
                                        type="checkbox"
                                        name={`${module.moduleName.toLowerCase()}_${permission}`}
                                        onChange={handleChange}
                                        checked={module[permission] || false}
                                        className="form-checkbox mr-5"
                                      />
                                    </Td>
                                  ))}
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DrawerBody>
          <center>
            {" "}
            <DrawerFooter style={{ display: "inline-block" }}>
              <div className=" d-flex gap-2 justify-content-center">
                <button className="cancel-button" onClick={props.closeDrawer}>
                  Cancel
                </button>
                {/* <button className='create-button' style={{ backgroundColor: "#5d87ff" }} onClick={handleSubmit}>Submit</button> */}
                <button
                  className="create-button"
                  onClick={(e) => {
                    !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e);
                  }}
                >
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default UserDrawer;
